import { FC } from 'react';
import { hTMLWrapperContainerStyle } from './HTMLWrapperEntry.styles.css';
import { ValidNode } from '../../../types';

export type WrapperProps = {
    node: ValidNode;
    type?: string;
};

const HTMLWrapperEntry: FC<WrapperProps> = ({ node }) => {
    const { fields, sys } = node.data.target;

    const html = { __html: fields.code };
    const entryId = sys.id;

    const fieldType = fields.type === 'Banner' ? 'banner' : 'iframe';

    return (
        <div
            className={`cmsHtmlWrapper ${hTMLWrapperContainerStyle}`}
            data-testid={`${fieldType}-${entryId}`}
            dangerouslySetInnerHTML={html}
        />
    );
};

export default HTMLWrapperEntry;
